<template>
    <!-- <div class="share" @click="shareLink">
        <img @mouseover="show=true" @mouseout="show=false" :src="share" alt="">
        <transition name="slide">
            <div class="tips" v-if="show">
                Share Referral Link
            </div>
        </transition>
    </div> -->
    <!-- <div class="side-menu-card share font-weight-bold" @click="shareLink" >
        <span>Share Referral Link</span>
        <div class="share-menu">
        </div>
    </div> -->
    <div></div>
</template>
<script>
import  share from '../assets/img/common/share.png'//推荐链接分享
import { getReferralLink } from '@/api/teachinfo'
export default {
    data:()=>({
        share:share,
        referralLink:''
    }),
    methods:{
        shareLink(){
            getReferralLink().then(res => {
                if (res.data.ErrorCode == 0) {
                    this.referralLink = res.data.Body.ReferralUrl;
                    const input = document.createElement('input')
                    document.body.appendChild(input)
                    input.setAttribute('value',this.referralLink)
                    input.select()
                    if (document.execCommand('copy')) {
                        document.execCommand('copy')
                    }
                    document.body.removeChild(input)
                    this.$root.$alertTips('Refereal link is copied.<br>Share it now to get more referral bonus!','success')
                }else{
                    this.$root.$alertTips(res.data.Msg,'error');
                }
            })
        }
    }
}
</script>